<script setup>
import useStore from "../store";
import {computed, onMounted, ref, watch} from "vue";

const props = defineProps({
  errors: Array,
  submitted: {
    default: false,
    type: Boolean,
  },
})

const store = useStore();
const answers = ref([])
const model = defineModel({ default: false })
const emit = defineEmits(['errors'])

const questions = computed(() => {
  return store.uniqueAttractions
      .filter((att) => att.questions && att.questions.length > 0)
      .reduce((curr, att) => {
    let questions = att.questions;

    return [...curr, ...questions]
  }, [])
})


watch(answers, (newValue) => {
  let valid = true;

  for (const answer of answers.value) {
    if (answer.required && answer.message.length < 1){
      valid = false;
    }
  }

  model.value = valid

  store.answers = answers.value
}, { deep: true });


watch(questions, (newValue) => {

  let items = [...answers.value];

  for (const question of questions.value) {
    const found = answers.value.find(answer => answer.label === question.label)

    if (!found){
      items.push({
        label: question.label,
        message: '',
        required: question.required,
      })
    }
  }

  if (items.length){
    items = items.filter(item => {
      return questions.value.find(question => question.label === item.label)
    })
  }

  answers.value = items;
}, { deep: true });


watch([() => props.submitted, () => model.value], (newValue) => {
  if (props.submitted && !model.value){
    emit('errors', 'Please answer the required questions')
  }
})



</script>

<template>
    <div class="bg-light rounded-lg relative px-4 py-2 mb-2" v-if="answers.length > 0">
        <div class="relative" v-for="(answer, ind) in answers">
          <div class="customer-field pt-3">
            <label class="flex items-center" v-text="`${answer.label}${answer.required ? ' *' : ''}`"></label>
            <textarea
                :name="`answer_${ind}`"
                :id="`answer_${ind}`"
                data-testid="booking-question-answer"
                v-model="answer.message"
                class="w-full leading-tight p-4 rounded-sm border bg-white shadow-inner border-light focus:border-transparent focus:ring-2 focus:ring-primary focus:ring-inset focus:bg-white"
            ></textarea>
          </div>
        </div>

        <div v-if="props.submitted && !model"
             class="text-[#F54E4E] text-sm mt-1">
          Please answer the required questions
        </div>
    </div>
</template>
